import type {
  EmailVersion,
  FaxVersion,
  PhoneVersion,
  PointOfContactVersion,
} from '@festina/legalentity-general-types/legalentity'
import type { Optional } from '@festina-life/core'

export const isEmailVersion = (
  x: Optional<PointOfContactVersion>,
): x is EmailVersion => x?._type === 'EmailVersion'

export const isPhoneVersion = (
  x: Optional<PointOfContactVersion>,
): x is PhoneVersion => x?._type === 'PhoneVersion'

export const isFaxVersion = (
  x: Optional<PointOfContactVersion>,
): x is FaxVersion => x?._type === 'FaxVersion'
